import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFSelectMultiple.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
};

export default function RHFSelectMultiple({
  name,
  children,
  object = [],
  toShow = 'nombre',
  idToSearch = 'id',
  values,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error }, value }) => (
        <TextField
          {...field}
          select
          // value={values}
          fullWidth
          SelectProps={{
            multiple: true,
            value,
            renderValue: (selected) => {
              return selected
                ?.map((s) => {
                  const exist = object?.find((el) => (el[idToSearch] ?? '') === s);
                  return !exist ? '' : object?.find((el) => (el[idToSearch] ?? '') === s)[toShow] ?? '';
                })
                ?.join(', ');
            },
          }}
          error={!!error}
          helperText={error?.message}
          {...other}
        >
          {children}
        </TextField>
      )}
    />
  );
}
